var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMicrophone = function SvgMicrophone(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 361.59,
    height: 469.332,
    viewBox: "0 0 361.59 469.332",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone_3_",
    "data-name": "microphone (3)",
    transform: "translate(-58.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465",
    transform: "translate(58.767 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M390.832,29.526A100.9,100.9,0,0,0,218.543,102.19L83.838,258.157A55.823,55.823,0,0,0,77.716,322.1l-4.428,4.428a49.663,49.663,0,0,0,70.235,70.234l14.835-14.837a18.756,18.756,0,0,1,26.525,26.525l-39.027,39.027,21.854,21.854,39.027-39.026A49.663,49.663,0,0,0,136.5,360.073L121.668,374.91a18.756,18.756,0,0,1-26.525-26.525l4.8-4.8a55.876,55.876,0,0,0,62.254-7.061L318.165,201.817c.423.005.846.03,1.268.03a100.924,100.924,0,0,0,71.4-172.321ZM142,313.129A24.651,24.651,0,0,1,107.23,278.36L226.48,140.286a100.647,100.647,0,0,0,53.591,53.592ZM368.978,150.463a70.03,70.03,0,1,1,0-99.084A70.144,70.144,0,0,1,368.978,150.463Z",
    transform: "translate(-58.767 0)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMicrophone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Microphone.358e487a6a15da6f92e995fd042b63e0.svg";